import { atom } from 'jotai';
import { RESET } from 'jotai/utils';

import { addValue } from '@dte/otw-utils-core/src/lists/addValue';
import { removeValue } from '@dte/otw-utils-core/src/lists/removeValue';

export interface PendingIdUpdate {
	id: string;
	value: boolean;
}

export function createPendingIdsAtom() {
	const pendingIdsAtom = atom<string[]>([]);
	pendingIdsAtom.debugLabel = 'pendingIds';

	const pendingAtom = atom(
		(get) => {
			const updates = get(pendingIdsAtom);
			return updates?.length > 0;
		},
		(get, set, idUpdate: PendingIdUpdate | typeof RESET) => {
			if (idUpdate === RESET) {
				set(pendingIdsAtom, []);
				return;
			}

			let updates = get(pendingIdsAtom);
			const { id, value } = idUpdate;

			if (value) {
				updates = addValue(updates, id);
			} else {
				updates = removeValue(updates, id);
			}

			set(pendingIdsAtom, updates);
		},
	);
	pendingAtom.debugLabel = 'pending';

	return pendingAtom;
}
